module.exports = __webpack_public_path__ + "static/media/sacar.82dc0016.svg";